import React from "react";
import Header from "../../../commons/Header/Header";
import Footer from "../../../commons/Footer/Footer";
const ThankYouFr = (props) => {
  return (
    <>
    <Header en="/partner/form/thank-you" fr="/partenaires/formulaire/merci" lang="fr" />
    <div className="container mainDiv ab">
      <div className="row">
        <div className="col-xs-12 content">
          <h1 className="thank-you">Merci</h1>
          <div>
            <div className="row">
              <div className="col-lg-8">
                <p>Merci de votre intérêt pour un partenariat avec nous. Votre demande a bien été envoyée. Vous recevrez un courriel d'ici deux jours ouvrables vous invitant à créer un compte et à poursuivre le processus d'inscription électronique<br />
                Si vous avez déjà signé un contrat avec Travelance, veuillez envoyer un courriel à join@travelance.ca.</p>
              </div>
              <div className="col-lg-4">
                <div className="stickyDiv">
                  <div className="holder_block">
                    <h2>Quick Links</h2>
                    <ul className="list">
                      <li><a href="/reclamations">Réclamations</a></li>
                      <li><a href="https://www.getreliable.com/getreliable/">Portail de vente en ligne</a></li>
                      <li><a href="/au-sujet-de-notre-assureur">Au sujet de notre assureur</a></li>
                      <li><a href="/partenaires/sessions-de-formation-en-ligne">Sessions de formation en ligne</a></li>
                      <li><a href="https://www.travel.gc.ca/travelling/advisories/">Conseils aux voyageurs</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer lang="fr" />
    </>
  );
}

export default ThankYouFr;
